
import collect from 'collect.js'
import Sort from '@/assets/icons/fontawesome/light/sort-alt.svg?inline'
import List from '@/assets/icons/fontawesome/light/list.svg?inline'
import MapIcon from '@/assets/icons/map.svg?inline'
import Filters from '@/assets/icons/filters.svg?inline'

export default {
  components: {
    Sort,
    List,
    Filters,
    MapIcon,
  },
  async asyncData({ $axios, app, i18n, params, query, $config: { baseURL } }) {
    let checkIn = app.$moment().locale('en').format('YYYY-MM-DD')
    let checkOut = app
      .$moment()
      .locale('en')
      .add(1, 'days')
      .format('YYYY-MM-DD')
    let guests = [{ adults: 2, children: [] }]

    if (
      query.check_in &&
      query.check_in >= app.$moment().locale('en').format('YYYY-MM-DD')
    ) {
      checkIn = app.$moment(query.check_in).locale('en').format('YYYY-MM-DD')
      if (query.check_out && query.check_out > query.check_in) {
        if (
          app
            .$moment(query.check_out)
            .diff(app.$moment(query.check_in), 'days') > 30
        ) {
          checkOut = app
            .$moment(checkIn)
            .locale('en')
            .add(30, 'days')
            .format('YYYY-MM-DD')
        } else {
          checkOut = app
            .$moment(query.check_out)
            .locale('en')
            .format('YYYY-MM-DD')
        }
      } else {
        checkOut = app
          .$moment(query.check_in)
          .locale('en')
          .add(1, 'days')
          .format('YYYY-MM-DD')
      }
    }

    if (query.check_out && query.check_out > checkIn) {
      if (
        app.$moment(query.check_out).diff(app.$moment(checkIn), 'days') > 30
      ) {
        checkOut = app
          .$moment(checkIn)
          .locale('en')
          .add(30, 'days')
          .format('YYYY-MM-DD')
      } else {
        checkOut = app
          .$moment(query.check_out)
          .locale('en')
          .format('YYYY-MM-DD')
      }
    }

    if (query.guests) {
      guests = query.guests.split('|').map((r) => {
        return {
          adults: r.split(',').filter((v) => v === 'a').length,
          children: r.split(',').filter((v) => v > 0),
        }
      })
    }

    return await $axios
      .$get('/v3/services/place/details', {
        params: {
          // continent: true,
          // country: true,
          // hotels: true,
          // image: true,
          place_id: params.placeId,
        },
      })
      .then((response) => {
        return {
          title: response.result.name,
          photo_reference: response.result.photos
            ? response.result.photos[0].photo_reference
            : null,
          destination: response.result,
          place: {
            type: 'place',
            id: response.result.place_id,
            // slug: response.data.slug,
            name: response.result.name,
            title: response.result.name,
            types: response.result.types,
            query_type: ['lodging', 'point_of_interest'].some((el) =>
              response.result.types.includes(el),
            )
              ? 'property'
              : 'destination',
            // country: response.data.country,
            _geoloc: response.result.geometry.location,
          },
          start: checkIn,
          end: checkOut,
          rooms: guests,
          // showMap: query.showMap === 'true',
          schemaBreadcrumbList: {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: i18n.t('Travelor'),
                item: baseURL + app.localePath('/'),
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: i18n.t('Hotels'),
                item: baseURL + app.localePath('hotels'),
                // }, {
                //   '@type': 'ListItem',
                //   position: 3,
                //   name: i18n.t('Hotels in {destination}', {
                //     destination: response.data.country.title
                //   }),
                //   item: baseURL + app.localePath({
                //     name: 'hotels-destination-countrySlug',
                //     params: { countrySlug: response.data.country.slug }
                //   })
                // }, {
                //   '@type': 'ListItem',
                //   position: 4,
                //   name: i18n.t('Hotels in {destination}', {
                //     destination: response.data.title
                //   }),
                //   item: baseURL + app.localePath({
                //     name: 'hotels-destination-countrySlug-destinationSlug',
                //     params: {
                //       countrySlug: response.data.country.slug,
                //       destinationSlug: response.data.slug
                //     }
                //   })
              },
              {
                '@type': 'ListItem',
                position: 3,
                name: i18n.t('Compare hotel prices near {destination}', {
                  destination: response.result.name,
                }),
                item:
                  baseURL +
                  app.localePath({
                    name: 'hotels-place-placeId-results',
                    params: {
                      // countrySlug: response.data.country.slug,
                      placeId: params.placeId,
                    },
                  }),
              },
            ],
          },
        }
      })
      .catch(() => {
        // app.$auth.reset()
        // redirect(app.localePath('/'))
      })
  },
  data() {
    return {
      meta: {},
      filter: {},
      time: null,
      expired: false,
      results: [],
      loaders: [],
      view: 'list',
      cancel: null,
      request: null,
      showMap: false,
      loading: false,
      filters: false,
      searching: true,
      filtering: false,
      destroying: false,
      searchOpen: false,
      filtersModal: false,
      available_filters: {},
      aggregator: 'travolutionary',
    }
  },
  head() {
    return {
      title: this.$i18n.t('Compare hotel prices near {destination}', {
        destination: this.title,
      }),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$i18n.t(
            'Competitive prices, personal and professional service in booking hotels, flights and other tourism products.',
          ),
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.$i18n.t('Compare hotel prices near {destination}', {
            destination: this.title,
          }),
        },
        {
          hid: 'og:title',
          name: 'og:title',
          content: this.$i18n.t('Compare hotel prices near {destination}', {
            destination: this.title,
          }),
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: this.$i18n.t(
            'Competitive prices, personal and professional service in booking hotels, flights and other tourism products.',
          ),
        },
      ],
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        {
          innerHTML: JSON.stringify(this.schemaBreadcrumbList),
          type: 'application/ld+json',
        },
      ],
    }
  },
  computed: {
    loadingPercentage() {
      if (this.results.length && this.meta && this.meta.all) {
        return Math.round((this.results.length / this.meta.all.total) * 100)
      }
      return 0
    },
  },
  watch: {
    priceDisplay(newDisplay, oldDisplay) {
      if (this.isAgent && newDisplay !== oldDisplay) {
        this.createSession()
      }
    },
    country(newCountry, oldCountry) {
      if (newCountry !== oldCountry) {
        this.createSession()
      }
    },
    currency(newCurrency, oldCurrency) {
      if (newCurrency !== oldCurrency) {
        this.getSession(
          this.$route.query.session,
          this.$route.query,
          'searching',
        )
      }
    },
    showMap(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.viewChanged(newValue)
      }
    },
    '$route.query': {
      handler(newQuery, oldQuery) {
        const search = collect(newQuery).only([
          'check_in',
          'check_out',
          'country',
          // 'currency',
          'guests',
        ])

        const oldSearch = collect(oldQuery).only([
          'check_in',
          'check_out',
          'country',
          // 'currency',
          'guests',
        ])

        const filter = collect(newQuery).only([
          'sort_by',
          'sort',
          'min_price',
          'max_price',
          'distance',
          'stars',
          'hotel_facilities',
          'room_facilities',
          'property_types',
          // 'currency',
          'hotel_name',
          'rating',
          'map_area',
          'take',
        ])

        const oldFilter = collect(oldQuery).only([
          'sort_by',
          'sort',
          'min_price',
          'max_price',
          'distance',
          'stars',
          'hotel_facilities',
          'room_facilities',
          'property_types',
          // 'currency',
          'hotel_name',
          'rating',
          'map_area',
          'take',
        ])

        if (
          oldSearch.values().all().toString() !==
          search.values().all().toString()
        ) {
          this.start = newQuery.check_in
          this.end = newQuery.check_out
          this.createSession()
        } else if (
          oldFilter.values().all().toString() !==
          filter.values().all().toString()
        ) {
          this.getSession(this.$route.query.session, filter.all(), 'loading')
        }

        if (
          this.$route.query.max_price ||
          this.$route.query.min_price ||
          this.$route.query.distance ||
          this.$route.query.stars ||
          this.$route.query.hotel_facilities ||
          this.$route.query.room_facilities ||
          this.$route.query.property_types ||
          this.$route.query.hotel_name ||
          this.$route.query.rating
        ) {
          this.filters = true
        } else if (
          !this.$route.query.max_price &&
          !this.$route.query.min_price &&
          !this.$route.query.distance &&
          !this.$route.query.stars &&
          !this.$route.query.hotel_facilities &&
          !this.$route.query.room_facilities &&
          !this.$route.query.property_types &&
          !this.$route.query.hotel_name &&
          !this.$route.query.rating
        ) {
          this.filters = false
        }
      },
    },
  },
  mounted() {
    const filter = collect(this.$route.query).only([
      'sort_by',
      'sort',
      'min_price',
      'max_price',
      'distance',
      'stars',
      'hotel_facilities',
      'room_facilities',
      'property_types',
      'currency',
      'hotel_name',
      'rating',
    ])

    if (
      this.$route.query.session &&
      this.$route.query.currency === this.currency
    ) {
      this.getSession(this.$route.query.session, filter.all())
    } else if (
      this.$route.query.check_in &&
      this.$route.query.check_out &&
      this.$route.query.guests
    ) {
      this.createSession()
    }
  },
  destroyed() {
    this.destroying = true
  },
  methods: {
    async createSession(count = 1) {
      if (this.loading || this.destroying) {
        return
      }

      this.searching = true
      this.loading = true
      this.results = []
      this.loaders = [1, 2, 3, 4, 5, 6]
      let params = {}
      const query = {
        check_in: this.start,
        check_out: this.end,
        country: this.country,
        currency: this.currency,
        fid: this.getFid,
        net: 1,
        // net: this.priceDisplay === 'net' ? 1 : 0,
        query_type: ['lodging', 'point_of_interest'].some((el) =>
          this.destination.types.includes(el),
        )
          ? 'property'
          : 'destination',
        query_text: this.destination.name,
        guests: this.rooms
          .map((r) => {
            const room = []
            for (let a = 0; a < r.adults; a++) {
              room.push('a')
            }
            for (let c = 0; c < r.children.length; c++) {
              room.push(r.children[c])
            }
            return room.toString().replace(/,/g, ':')
          })
          .toString()
          .replace(/,/g, '|')
          .replace(/:/g, ','),
      }

      if (this.aggregator === 'innstant') {
        params = {
          aggregator: 'innstant',
          type: 'location',
          ids: this.destination.id,
          ...query,
        }
      } else {
        params = {
          aggregator: 'travolutionary',
          type: 'geoloc',
          latitude: this.$route.query.latitude,
          longitude: this.$route.query.longitude,
          radius: this.$route.query.radius,
          ...query,
        }
      }

      try {
        await this.$axios
          .$post('/v3/sessions', params)
          .then(async (response) => {
            this.onSessionChange(response.session)

            const options = collect(this.$route.query)
              .only([
                'sort_by',
                'sort',
                'min_price',
                'max_price',
                'distance',
                'stars',
                'hotel_facilities',
                'room_facilities',
                'property_types',
                'currency',
                'hotel_name',
                'rating',
              ])
              .all()

            await this.getSession(response.session, options, 'loading', count)
          })
      } catch (err) {
        // this.$sentry.captureException(err)
      }

      this.loading = false
    },

    async getSession(session, options = {}, action = 'loading', count = 1) {
      if (this.destroying) {
        return
      }

      if (this.request) {
        this.request.cancel()
      }

      const axiosSource = this.$axios.CancelToken.source()
      this.request = { cancel: axiosSource.cancel, msg: 'Loading...' }

      this.addSearch({
        router: this.$route.fullPath,
        params: this.$route.query,
        name: this.title,
        check_in: this.start,
        check_out: this.end,
        image: this.photo_reference,
        aggregator: 'travolutionary',
        destination: this.place,
        // destination: {
        //   id: this.destination.id,
        //   name: this.destination.name,
        //   title: this.destination.title,
        //   slug: this.destination.slug,
        //   country: this.destination.country,
        //   _geoloc: this.destination._geoloc
        // }
      })

      if (['load', 'loading'].includes(action)) {
        this.loading = true
        this.loaders = [1, 2, 3, 4, 5, 6]
      } else if (action === 'filtering') {
        this.filtering = true
      } else if (action === 'searching') {
        this.searching = true
        this.loaders = [1, 2, 3, 4, 5, 6]
      }

      try {
        await this.$axios
          .$get(`/v3/session/${session}`, {
            cancelToken: axiosSource.token,
            progress: false,
            params: {
              // sort_by: options.sort_by || (['lodging', 'point_of_interest'].some(el => this.destination.types.includes(el)) ? 'distance' : 'popular'),
              sort_by: options.sort_by || 'popular',
              // sort: options.sort || (['lodging', 'point_of_interest'].some(el => this.destination.types.includes(el)) ? 'asc' : 'desc'),
              sort: options.sort || 'desc',
              min_price: options.min_price,
              max_price: options.max_price,
              distance: options.distance,
              stars: options.stars,
              hotel_facilities: options.hotel_facilities,
              room_facilities: options.room_facilities,
              property_types: options.property_types,
              currency: this.currency,
              hotel_name: options.hotel_name,
              rating: options.rating,
              skip: options.skip || 0,
              take: options.take || 48,
              map_area: options.map_area,
            },
          })
          .then((response) => {
            this.onSessionChange(response.session)

            if (response.status === 'error' && count < 5) {
              return this.createSession(count)
            }

            if (action === 'load') {
              this.results = collect(this.results.concat(response.data))
                .unique('hotel_id')
                .all()
            } else {
              this.results = response.data
            }

            this.meta = response.meta
            this.filter = response.filter
            this.aggregator = response.search.aggregator

            if (response.status !== 'running') {
              this.loaders = []
              this.searching = false
            }

            if (response.created_at) {
              this.time = this.$moment
                .utc(response.created_at)
                .add(this.$config.sessionLifetime, 'minutes')
                .diff(this.$moment.utc(), 'millisecond')
            }

            if (response.status === 'running' && count < 30) {
              setTimeout(async () => {
                await this.getSession(
                  response.session,
                  options,
                  'running',
                  count + 1,
                )
              }, 3000)
            } else if (
              this.results.length < response.meta.all.total &&
              response.meta.count
            ) {
              this.loaders = []
              this.loading = false
              // this.loadMore()
            }
          })
      } catch (err) {
        this.loading = false

        if (
          this.$route.query.check_in &&
          this.$route.query.check_out &&
          this.$route.query.guests &&
          typeof err.response.data === 'object' &&
          err.response.data.errors?.session
        ) {
          this.createSession(count)
        }
      }

      // this.loaders = []
      this.loading = false
      this.filtering = false
    },

    loadMore() {
      const query = collect(this.$route.query)
        .only([
          'sort_by',
          'sort',
          'min_price',
          'max_price',
          'distance',
          'stars',
          'hotel_facilities',
          'room_facilities',
          'property_types',
          'currency',
          'hotel_name',
          'rating',
          'map_area',
          'take',
        ])
        .all()

      if (!this.loading && this.results.length < this.meta.filtered.total) {
        this.getSession(
          this.$route.query.session,
          {
            ...query,
            skip: this.results.length,
            take: query.take ?? 48,
          },
          'load',
        )
      }
    },

    onSessionChange(session) {
      const data = Object.assign({}, this.$route.query)

      data.session = session

      this.$router.replace({ query: data }).catch(() => {})
    },

    clearFilters() {
      const query = Object.assign({}, this.$route.query)
      delete query.stars
      delete query.hotel_facilities
      delete query.room_facilities
      delete query.property_types
      delete query.min_price
      delete query.max_price
      delete query.distance
      delete query.rating
      delete query.map_area
      this.$router.replace({ query })
    },

    viewChanged(type) {
      const data = Object.assign({}, this.$route.query)
      // data.showMap = type
      if (type) {
        if (!this.filters) {
          data.stars = '4,5'
        }
        data.take = 72
      }
      if (!type) {
        data.take = 48
        delete data.map_area
        if (data.stars && data.stars === '4,5') {
          delete data.stars
        }
      }
      this.$router
        .replace({
          query: collect(data).filter().all(),
        })
        .catch(() => {})
    },

    loadMap(center) {
      if (!this.loading) {
        const query = Object.assign({}, this.$route.query)
        query.map_area = `${center.center.lat},${center.center.lng},75000`
        query.take = 72
        this.$router
          .replace({
            query: collect(query).filter().all(),
          })
          .catch(() => {})
      }
    },
    handleTimerExpired() {
      this.expired = true
    },
  },
}
